import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { ContactFormFullwidth } from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  Problem,
  Solution,
  Examples,
  HowWeBuild,
  TechnologyStack,
  LearnMore,
  OtherServices,
} from './subcomponents';
import './ProductDesignAndDevelopment.scss';

class ProductDesignAndDevelopment extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <div className={'single-page single-page--hero pdad'}>
        <Banner />
        <Problem />
        <Solution />
        <LazyLoad offset={200}>
          <Examples allArticles={allArticles} />
        </LazyLoad>
        <LazyLoad offset={200}>
          <HowWeBuild />
        </LazyLoad>
        <TechnologyStack />
        <ContactFormFullwidth
          name={'pdad-contact-form'}
          pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x8y'}
        />
        <LearnMore allArticles={allArticles} />
        <OtherServices />
      </div>
    );
  }
}

export default ProductDesignAndDevelopment;
